import { type StateStorage } from 'zustand/middleware';

// isBrowserStorageAvailable function is modified and based off of https://git.engelvoelkers.com/ev/customer-platform/spearhead/ui-core-components/-/blob/main/src/utils/isLocalStorageAvailable.ts
export const isBrowserStorageAvailable = (typeOfStorage: 'localStorage' | 'sessionStorage'): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const test = 'test';

  try {
    window[typeOfStorage].setItem(test, test);
    window[typeOfStorage].removeItem(test);
    return true;
  } catch {
    return false;
  }
};

export class TemporaryStorage implements StateStorage {
  private storage: Map<string, string> = new Map();

  getItem(key: string) {
    return this.storage.get(key) ?? null;
  }

  setItem(key: string, value: string) {
    this.storage.set(key, value);
  }

  removeItem(key: string) {
    this.storage.delete(key);
  }

  clear() {
    this.storage.clear();
  }
}

export const safeLocalStorage = isBrowserStorageAvailable('localStorage') ? window.localStorage : new TemporaryStorage();
export const safeSessionStorage = isBrowserStorageAvailable('sessionStorage') ? window.sessionStorage : new TemporaryStorage();
